"use strict";

var CONSENT_COOKIE = "babolatCookieConsent";
var COOKIE_LIFETIME_DAYS = 365;

/**
 * Reads a cookie value by name.
 * @param {string} name - Cookie name
 * @returns {string|null} Decoded value, or null when the cookie is not set
 */
function readCookie(name) {
    var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));

    return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Writes a cookie on the current domain.
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Lifetime in days
 * @returns {void}
 */
function writeCookie(name, value, days) {
    var expires = new Date();

    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/;SameSite=Lax";
}

/**
 * Normalises the OneTrust category list into a stable, comparable form.
 * OneTrust can repeat categories and can emit them in a different order
 * between calls, so the raw value cannot be compared against the stored one
 * without producing false "changed" verdicts and redundant server calls.
 * @param {string} value - Raw OnetrustActiveGroups value
 * @returns {string} Pipe separated, de-duplicated, alphabetically sorted list
 */
function normaliseGroups(value) {
    var unique = [];

    value.split(",").forEach(function (group) {
        var trimmed = group.trim();

        if (trimmed && unique.indexOf(trimmed) === -1) {
            unique.push(trimmed);
        }
    });

    return unique.sort().join("|");
}

/**
 * Reads the configuration that htmlHead renders into the document head.
 * @returns {Object|null} Object holding the consent group and the session
 *                        endpoint, or null when the carrier is missing
 */
function getConfig() {
    var group = $("meta[name='tracking-consent-group']").attr("content");
    var url = $("meta[name='tracking-consent-url']").attr("content");

    return (group && url) ? { group: group, url: url } : null;
}

/**
 * Mirrors the OneTrust decision into Commerce Cloud.
 * The cookie is what the consentTracking middleware reads on uncached requests.
 * The endpoint call applies the same decision to the current session straight
 * away, which is what covers cached pages where no controller runs.
 * @returns {void}
 */
function syncConsent() {
    var config = getConfig();

    if (!config || typeof window.OnetrustActiveGroups !== "string") {
        return;
    }

    var groups = normaliseGroups(window.OnetrustActiveGroups);
    var previous = readCookie(CONSENT_COOKIE);

    writeCookie(CONSENT_COOKIE, groups, COOKIE_LIFETIME_DAYS);

    // Only call the server when the decision actually changed.
    if (previous === groups) {
        return;
    }

    $.ajax({
        url: config.url,
        type: "get",
        dataType: "json",
        data: { consent: groups.split("|").indexOf(config.group) > -1 }
    });
}

module.exports = function () {
    /**
     * OneTrust loads async, so it can initialize before or after this bundle.
     * The event covers later consent changes, OptanonWrapper covers the hook
     * OneTrust calls itself, and the direct call covers the case where OneTrust
     * had already resolved its groups before this ran. syncConsent is a no-op
     * when the decision has not changed, so the overlap costs nothing.
     */
    window.addEventListener("OneTrustGroupsUpdated", syncConsent);
    window.OptanonWrapper = syncConsent;

    syncConsent();
};
